import { MAX_EXPENSE_AMOUNT } from "@/utils/utils";
import { formatDollars } from "@common/components/utils";
import { CustomFieldFormValues } from "@common/utils/graphql";
import * as z from "zod";

export const expenseFormSchemaObject = {
  id: z.number().optional(),
  merchant: z.string({
    required_error: "You must select a merchant",
  }),
  expenseCategoryGLId: z.string().optional(),
  amount: z.coerce
    .number()
    .min(0.01, { message: "You must enter an amount" })
    .max(MAX_EXPENSE_AMOUNT, {
      message: `Amount cannot exceed ${formatDollars(MAX_EXPENSE_AMOUNT)}`,
    })
    .default(0),
  date: z
    .date({
      required_error: "You must date the reimbursement",
    })
    .refine((date: Date) => new Date() >= date, "Date cannot be in the future"),
  notes: z.string().optional(),
  receipt: z.any().default(null),
  reportId: z.string().optional(),
  transactionId: z.number().optional(),
  attendeeEmails: z.string().array().default([]),
};

export const ExpenseFormSchema = z.object(expenseFormSchemaObject);
export type ExpenseFormValues = z.infer<typeof ExpenseFormSchema> & {
  customFieldEntries: CustomFieldFormValues;
};

export const SelectedExpenseFormSchema = z.object({
  type: z
    .string({
      required_error: "You need to select a report.",
    })
    .default("new"),
});
